import '../assets/css/card.css'

function Card(props){
    
    const {image} = props 

    return(
        <>
            <div className='card'>
                <img className="card__img" src={image} />
            </div>
        </>
    )
}

export default Card;